import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useOrder } from "../context/OrderContext";
import "./OrderComplete.css";

const OrderComplete = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const { setActiveOrder, setIsProcessing } = useOrder();

  useEffect(() => {
    // Clear active order after showing completion
    const timer = setTimeout(() => {
      setActiveOrder(null);
      setIsProcessing(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, [setActiveOrder, setIsProcessing]);

  const handleBackToMenu = () => {
    setActiveOrder(null);
    setIsProcessing(false);
    navigate("/");
  };

  return (
    <div className="order-complete">
      <div className="complete-container">
        <div className="complete-icon">🎉</div>
        <h1>Bon Appétit!</h1>
        <p className="complete-message">
          Your order is ready. Enjoy your meal!
        </p>
        <p className="order-id">Order #{orderId}</p>
        <button className="back-to-menu-btn" onClick={handleBackToMenu}>
          Back to Menu
        </button>
      </div>
    </div>
  );
};

export default OrderComplete;
